import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { duplicateService } from '@/services/duplicate';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

export function useDuplicateCycleDetail() {
    const route = useRoute();
    const router = useAppRouter();

    const cycle = ref(null);
    const { fetchAllMatches, gameMatchCache } = useGameMatchList();

    const fetch = async () => {
        await fetchAllMatches();

        const cycleResponse = await duplicateService.cycle.get(route.params.cycleId);
        if (cycleResponse.code !== ResponseCode.Ok) {
            router.push({ name: ROUTE_NAME_DUPLICATE.CYCLE.INDEX });
            return;
        }

        const result = cycleResponse.data;
        const duplicateResponse = await duplicateService.item.get(result.duplicateItemId);
        if (duplicateResponse.code !== ResponseCode.Ok) {
            router.push({ name: ROUTE_NAME_DUPLICATE.CYCLE.INDEX });
            return;
        }

        const duplicate = duplicateResponse.data;
        result.itemName = duplicate.name;
        result.itemGame = duplicate.game;
        result.matchId = duplicate.matchId;
        result.matchName = gameMatchCache.value.get(duplicate.matchId)?.label;

        cycle.value = result;
    };

    return { cycle, fetch };
}
